import { useState, useEffect } from 'react';

import { useInView } from "react-intersection-observer";
import styles from './Stats.module.css'

function Stats() {
  const { ref, inView } = useInView();

  const [students, setStudents] = useState(0);
  const [instructionHours, setInstructionHours] = useState(0);
  const [volunteers, setVolunteers] = useState(0);
  const [classHours, setClassHours] = useState(0);
  const [schools, setSchools] = useState(0);

  useEffect(() => {
    if (!inView) return;

    const maxStudents = 50;
    const maxClassHours = 20;
    const maxSchools = 6;
    const maxInstructionHours = 65;
    const maxVolunteers = 27;

    const participantInterval = setInterval(() => {
      setStudents((students) => Math.min(students + 1, maxStudents));
    }, 1500 / maxStudents);
    const instructionHoursInterval = setInterval(() => {
      setInstructionHours((hours) => Math.min(hours + 1, maxInstructionHours));
    }, 1500 / maxInstructionHours);
    const volunteersInterval = setInterval(() => {
      setVolunteers((volunteers) => Math.min(volunteers + 1, maxVolunteers));
    }, 1500 / maxVolunteers);
    const classHoursInterval = setInterval(() => {
      setClassHours((volunteers) => Math.min(volunteers + 1, maxClassHours));
    }, 1500 / maxClassHours);
    const schoolsInterval = setInterval(() => {
      setSchools((schools) => Math.min(schools + 1, maxSchools));
    }, 1500 / maxSchools);

    return () => {
      clearInterval(participantInterval);
      clearInterval(instructionHoursInterval);
      clearInterval(classHoursInterval);
      clearInterval(schoolsInterval);
      clearInterval(volunteersInterval);
    };
  }, [inView]);

  return (
    <div className={styles.Stats}>
      <div className={styles.Format}>
        <div>
          <h1>{classHours}+</h1>
          <p><b>Class Hours</b></p>
        </div>
        <div>
          <h1>{instructionHours}+</h1>
          <p><b>Instruction Hours ⓘ</b></p>
        </div>
      </div>
      <div className={styles.Format}>
        <div>
          <h1>{students}+</h1>
          <p><b>Students</b></p>
        </div>
        <div>
          <h1>{volunteers}+</h1>
          <p><b>Volunteers</b></p>
        </div>
        <div>
          <h1>{schools}+</h1>
          <p><b>Schools Reached</b></p>
        </div>
      </div>
      <div className={styles.Trigger} ref={ref} />
    </div>
  );
};

export default Stats;